import { styles } from './styles';
import { INewsItemType } from '../../../../types';
import useLanguage from '../../../../utils/customHook';
import ReactHtmlParser from 'react-html-parser';

type Props = {
  newsItemData: INewsItemType | undefined;
};

export default function SelectedItemContainer({ newsItemData }: Props) {
  const { lang } = useLanguage();
  const isEnglish = lang.EN;

  if (!newsItemData) return null;

  const title = isEnglish ? newsItemData.title?.en : newsItemData.title?.fi;

  return (
    <styles.SelectedItemContainer>
      {title && (
        <styles.BlackColorHeaderStyle>{title}</styles.BlackColorHeaderStyle>
      )}
      <styles.TextBoxBiggerGaps>
        {newsItemData.content?.map(
          (data, index) =>
            data.value !== null && (
              <styles.SelectedItemText key={index}>
                <styles.SelectedItemName>
                  {isEnglish ? data.name.en + ':' : data.name.fi + ':'}
                </styles.SelectedItemName>
                <styles.SelectedItemValue>
                  {ReactHtmlParser(data.value)}
                </styles.SelectedItemValue>
              </styles.SelectedItemText>
            )
        )}
      </styles.TextBoxBiggerGaps>
    </styles.SelectedItemContainer>
  );
}
